import { useState, useRef, useCallback } from 'react';

export interface Toast {
  message: string;
  type: 'success' | 'error';
}

export interface UseToastResult {
  toast: Toast | null;
  showToast: (message: string, type?: 'success' | 'error') => void;
  clearToast: () => void;
}

const TOAST_DURATION_MS = 3500;

export function useToast(): UseToastResult {
  const [toast, setToast] = useState<Toast | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const showToast = useCallback((message: string, type: 'success' | 'error' = 'success') => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type });
    timerRef.current = setTimeout(() => setToast(null), TOAST_DURATION_MS);
  }, []);

  const clearToast = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(null);
  }, []);

  return { toast, showToast, clearToast };
}
